import type { RouterProps } from 'wouter';
import { ExternalAccountDetailView } from 'components/pages/Integrations/ExternalAccountDetailView';
import { ExternalAccountsListView } from 'components/pages/Integrations/ExternalAccountsListView';
import { LinkDetailView } from 'components/pages/Integrations/LinkDetailView';
import { DecodedParamsRoute } from 'components/routing/DecodedParamsRoute';
import React, { Suspense } from 'react';
import { makePath } from 'utils/routes';
import { Link, Redirect, Route, Router, Switch } from 'wouter';

import { LoadingTable } from '@fragment/ui/src/components/LoadingTable/LoadingTable';

import { IntegrationSettingsLayout } from './IntegrationSettingsLayout';
import { IntegrationsMainView } from './IntegrationsMainView';

export const IntegrationsDesigner = ({
  base,
  hook,
  matcher,
}: Partial<RouterProps>): ReturnType<typeof Router> => (
  <Suspense
    fallback={
      <IntegrationSettingsLayout
        summarySection={<LoadingTable rows={4} cols={2} fullWidth={false} />}
      />
    }
  >
    <Router hook={hook} matcher={matcher} base={base} key={base}>
      <div className="flex flex-col gap-f3">
        <nav
          aria-label="Integration settings"
          className="flex flex-col items-start gap-f1"
        >
          <Link href="/">Integrations</Link>
          <DecodedParamsRoute path="/links/id/:linkId/:rest*">
            {({ linkId }) => (
              <>
                <Link href={makePath(['links', 'id', linkId])}>
                  External Accounts
                </Link>
                <Link href={makePath(['links', 'id', linkId, 'details'])}>
                  Details
                </Link>
              </>
            )}
          </DecodedParamsRoute>
        </nav>
        <Switch>
          <DecodedParamsRoute path="/" component={IntegrationsMainView} />
          <DecodedParamsRoute
            path="/links/id/:linkId"
            component={ExternalAccountsListView}
          />
          <DecodedParamsRoute
            path="/links/id/:linkId/accounts/:accountId"
            component={ExternalAccountDetailView}
          />
          <DecodedParamsRoute
            path="/links/id/:linkId/accounts/:accountId/tx/:txId"
            component={ExternalAccountDetailView}
          />
          <DecodedParamsRoute
            path="/links/id/:linkId/details"
            component={LinkDetailView}
          />
          <Route>
            <Redirect href="/" replace />
          </Route>
        </Switch>
      </div>
    </Router>
  </Suspense>
);
